export default __webpack_public_path__ + "fonts/inter-latin-200-normal.3f0a41e3da2bbea56c5b.woff2";